//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';
import { windowResizeMixin } from '~/mixins/resize';

export default {
  name: 'AboutUsTopBanner',
  mixins: [windowResizeMixin],
  components: {
    FCImage,
  },
  methods: {
    getDimensions({ ratio, maxWidth }) {
      const width = Math.min(this.mixinResize.initialWidth, maxWidth);
      const height = Math.ceil(width / ratio);

      return {
        width,
        height,
      };
    },
  },
  computed: {
    imageDimensions() {
      return {
        manPunching: this.getDimensions({ ratio: 375 / 208, maxWidth: 600 }),
        equipment: this.getDimensions({ ratio: 246 / 610, maxWidth: 320 }),
        womanPunching: this.getDimensions({ ratio: 340 / 610, maxWidth: 340 }),
      };
    },
  },
};
